import React from 'react';
import { InfoList, InfoListItem, StyledHintText, StyledModal } from './hp-example-modal.style';

const HpExampleModal = ({ isOpen, setOpenHPModal }) => {
    const infoLookup = {
        'Finance type': 'HP',
        'Borrow amount': '£6,000',
        Deposit: '£1,000',
        'Payment term': '48 months',
        'Representative APR': '17.8% (fixed)',
        'Annual fixed rate of interest': '17.8%',
        'Monthly payment': '£171.56',
        'Total charge for credit': '£2,234.88',
        'Total amount payable': '£9,234.88',
    };

    return (
        <StyledModal
            title="HP Representative example"
            displayAsSheetOnMweb
            isOpen={isOpen}
            onClose={() => setOpenHPModal(false)}
        >
            <InfoList>
                {Object.entries(infoLookup).map(([key, value]) => (
                    <InfoListItem>
                        <span className="info-key">{key}</span>
                        <span className="info-value">{value}</span>
                    </InfoListItem>
                ))}
            </InfoList>
            <StyledHintText>
                This representative example is for illustration purposes only and some vehicles may
                not match the lenders criteria by age or mileage. CarMoney may still be able to
                offer an alternative option to help you purchase the vehicle.
            </StyledHintText>
        </StyledModal>
    );
};

export default HpExampleModal;
